import axios from "axios";
import store from "../storeChat";

export const baseURL = `https://chatecorban-back.herokuapp.com/`;
//https://chatecorban-back.herokuapp.com/

const apiChat = axios.create({
  baseURL
});

apiChat.interceptors.request.use(config => {
  const { token } = store.getState().auth;
  const headers = { ...config.headers };

  if (token) {
    headers.authorization = token;
  }

  return { ...config, headers };
});

export default apiChat;



// WEBPACK FOOTER //
// ./src/services/apiChat.js